import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

// Una notificación con datos incompletos (clase o usuario borrado) tiraba un error de
// render y, sin un boundary, React desmontaba toda la Academia (pantalla en blanco).
// Con esto solo se cae el elemento que falla.
class NotificationErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Notification render error', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}

export default NotificationErrorBoundary;
